module.exports = __webpack_public_path__ + "static/img/190118-vaccine.f6922d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/190118-vaccine.png
// module id = M6NC
// module chunks = 0